'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('traccordion', traccordion);

    /** @ngInject */
    function traccordion($window, $rootScope) {
        return {
            link: link,
            restrict: 'A',
            scope: {
                traccordionConfig: '='
            }
        };

        function link(scope, iElement, iAttrs) {
            var jq = angular.element;

            var resolution = scope.traccordionConfig.resolution;
            var contentCopied = false;
            var showTraccordion = false;
            var showTraccordionBody = scope.traccordionConfig.opened;

            (function activate() {
                jq($window).on('resize', onWindowResize);
                jq(iElement).addClass('traccordion');
                jq(iElement).find('.traccordion-state').addClass('icon-arrow-down');
                jq(iElement).find('.traccordion-head').bind('click', toggleBody);
                jq(iElement).find('.traccordion-body').hide();
                onWindowResize();
                scope.$watch('traccordionConfig', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        toggleBody();
                    }
                }, true);
            })();

            function toggleBody() {
                showTraccordionBody = !showTraccordionBody;
                if (showTraccordionBody) {
                    jq(iElement).find('.traccordion-body').show();
                    jq(iElement).find('.traccordion-state').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                } else {
                    jq(iElement).find('.traccordion-body').hide();
                    jq(iElement).find('.traccordion-state').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                }
            }

            function onWindowResize() {
                var currentWidth = $window.innerWidth;

                // on window resize show/hide traccordion (set showTraccordion property)
                showTraccordion = currentWidth <= resolution;
                if (currentWidth <= resolution) {
                    jq(iElement).show();
                } else {
                    jq(iElement).hide();
                }
            }
        }
    }
})();